import { Injectable } from '@angular/core';
import { ListDataResponse } from '@interfaces/response.interface';
import { ProgramyStudiowStudentaDoSlubowaniaDto } from '@interfaces/studia/platforma-studenta/slubowanie-program-studiow-studenta.interface';
import { ApiBaseService } from '@services/api-base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SlubowanieProgramuStudiowStudentaService extends ApiBaseService {
  private readonly endpoint = `${this.apiUrl}/studia/platforma-studenta/slubowanie`;

  getRecords(): Observable<ListDataResponse<ProgramyStudiowStudentaDoSlubowaniaDto>> {
    return this.http.get<ListDataResponse<ProgramyStudiowStudentaDoSlubowaniaDto>>(this.endpoint);
  }

  akceptujSlubowanie(programStudiowStudentaSlubowanieId: string): Observable<null> {
    return this.http.put<null>(`${this.endpoint}/${programStudiowStudentaSlubowanieId}`, null);
  }
}
